export const ErrorMessageHelper = (context, message) => context.commit('app/addSnackbar', { message: message, color: 'red' }, { root: true })
